import React from "react";
import {TiTick} from 'react-icons/ti'
import {IoClose} from 'react-icons/io5'
export default function RowTable(props) {


    
    return (




        
        <tr className="aTable">
                                    <td>{props.item?.callTime}</td>
                                    <td>{props.item?.callDate}</td>
                                    <td>{props.item?.destinations}</td>
                                    <td>{props.item?.tripCode}</td>
                                    <td>{props.item?.payerStr}</td>
                                    <td>{props.item?.vehicaleTypeStr}</td>
                                    <td>{props.item?.totalAmount}</td>
                                    <td>{props.item?.driverCode}</td>

                                    <td>{props.item?.odati==1?<TiTick className="text-success"/>:<IoClose className="text-danger"/>}</td>
                                    <td>{props.item?.bigTark==1?<TiTick className="text-success"/>:<IoClose className="text-danger"/>}</td>
                                    <td>{props.item?.garantee==1?<TiTick className="text-success"/>:<IoClose className="text-danger"/>}</td>
                                    <td>{props.item?.hasBasket==1?<TiTick className="text-success"/>:<IoClose className="text-danger"/>}</td>
                                    <td>{props.item?.bulkyLoad==1?<TiTick className="text-success"/>:<IoClose className="text-danger"/>}</td>
                                    <td>{props.item?.returnOrigin==1?<TiTick className="text-success"/>:<IoClose className="text-danger"/>}</td>
                                 
                                </tr>
        

    )
}